// extracted by mini-css-extract-plugin
export default {"lastFetchBanner":"LastFetchBanner_lastFetchBanner__d4USu","updateLink":"LastFetchBanner_updateLink__HXnbu"};